<script>
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let label = ''
    export let value = 6
    export let step = 1
    export let max
    export let min
</script>

<style>
    label {
        width: 100%;
        font-size: 0.75rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }

    strong {
        font-weight: 500;
        font-size: 1.25em;
        margin-right: 0.275em;
    }

    span {
        color: var(--grey);
    }

    input[type='range'] {
        width: 100%;
        margin: 0.75rem 0;
        border: none;
        cursor: pointer;
        -webkit-appearance: none;
    }

    input[type='range']:focus {
        outline: none;
    }

    input[type='range']::-webkit-slider-runnable-track {
        height: 0.5rem;
        background-color: var(--blue);
        border-radius: 3px;
        transition: all 0.25s;
    }

    input[type='range']:focus::-webkit-slider-runnable-track {
        background-color: var(--grey);
    }

    input[type='range']::-webkit-slider-thumb {
        margin-top: -0.5rem;
        height: 1.5rem;
        width: 1rem;
        border: 1px solid var(--blue);
        border-radius: 3px;
        background-color: var(--white);
        -webkit-appearance: none;
        transition: all 0.25s;
    }
    
    input[type='range']:focus::-webkit-slider-thumb {
        background-color: var(--silver);
    }
</style>

<label>
    <strong>{value}</strong>
    <span>{label}</span>
    <input type="range" bind:value on:input={({ target }) => dispatch('update', target.value)} {min} {max} {step} />
</label>
